module.exports = __webpack_public_path__ + "img/post_box_letter.5c9a3d29.svg";